import { getLatestReleaseComment } from "../../../utils";

export const getMaxReleaseHistory = (history) =>
  history?.reduce(
    (latest, item) =>
      !latest || new Date(item.actionDate) > new Date(latest.actionDate)
        ? item
        : latest,
    null
  );

export const normalizeChapterAttachments = (capitulo, bloco) =>
  (capitulo.attachments || []).map((a) => ({
    ...a,
    fileName: a.attachment?.fileName,
    parentId: capitulo.id,
    blockId: capitulo.blockId,
    blockNumber: bloco?.number,
    chapterNumber: capitulo.number,
    type: "chapter",
    versionNumber: a.version,
  }));

export const buildChapterRealizedDates = (attachment) => ({
  ...attachment.attachment.deliveryControl.completionDates,
  delivery: attachment.attachment.deliveryControl?.completionDates?.received,
  channelRelease: attachment.attachment.releaseManagement?.channel
    ? getMaxReleaseHistory(attachment.attachment.releaseManagement?.history)
        ?.actionDate
    : null,
});

export const buildChapterReleasePayload = (attachment, capitulo, bloco) => ({
  ...attachment.attachment,
  blockId: capitulo.blockId,
  chapterId: capitulo.id,
  chapterAttachmentId: attachment.attachment.id ?? attachment.id,
  releaseType: "Channel",
  blockNumber: bloco.number,
  chapterNumber: capitulo.number,
  version: attachment.version,
  observation: getLatestReleaseComment(attachment.attachment.releaseManagement),
});

export const buildChapterOtherVersionsPayload = (capitulo, attachment, bloco) =>
  capitulo.attachments
    .filter((a) => a.id !== attachment.id)
    .map((a) => ({
      ...a.attachment,
      blockId: capitulo.blockId,
      chapterId: capitulo.id,
      chapterAttachmentId: a.id,
      releaseType: "Channel",
      blockNumber: bloco.number,
      chapterNumber: capitulo.number,
      version: a.version,
    }))
    .sort((a, b) => b.version - a.version);

export const toggleOneReducer = (prev, attachment) => {
  if (prev.some((f) => f.id === attachment.id)) {
    return prev.filter((f) => f.id !== attachment.id);
  }
  return [...prev, { ...attachment, versionNumber: attachment.version }];
};
